/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UserSendTestMail$Params {
  senderEmail?: string;
  senderName?: string;
  content?: string;
}

export function userSendTestMail(http: HttpClient, rootUrl: string, params?: UserSendTestMail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, userSendTestMail.PATH, 'post');
  if (params) {
    rb.query('senderEmail', params.senderEmail, {});
    rb.query('senderName', params.senderName, {});
    rb.query('content', params.content, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

userSendTestMail.PATH = '/api/User/test-mail';
